import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { SERVICES_META } from "@/lib/api";
import { ArrowUpRight } from "lucide-react";

export default function Services() {
  return (
    <section id="services" className="lk-section px-6 md:px-12 lg:px-24" data-testid="services-section">
      <div className="grid md:grid-cols-12 gap-8 mb-16">
        <div className="md:col-span-5">
          <span className="text-xs uppercase tracking-[0.3em] text-[#D4AF37]">Our Services</span>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light mt-4 leading-tight">
            Two booths.
            <br />
            <span className="italic gold-gradient-text">One unforgettable night.</span>
          </h2>
        </div>
        <div className="md:col-span-6 md:col-start-7 self-end">
          <p className="text-zinc-400 text-base md:text-lg leading-relaxed">
            Whether it's the timeless charm of a classic photo booth or the cinematic
            drama of a 360° rig — every Luxury Kingz setup is delivered with white-glove
            attention to detail.
          </p>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-6 md:gap-10">
        {Object.entries(SERVICES_META).map(([key, svc], idx) => (
          <motion.div
            key={key}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8, delay: idx * 0.15 }}
            data-testid={`service-card-${key}`}
            className="lk-card group relative overflow-hidden"
          >
            <div className="aspect-[4/3] w-full overflow-hidden">
              <img src={svc.image} alt={svc.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="p-8">
              <div className="flex items-start justify-between mb-3">
                <h3 className="font-serif text-3xl md:text-4xl">{svc.title}</h3>
                <ArrowUpRight className="w-6 h-6 text-[#D4AF37] opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
              <p className="italic text-[#D4AF37] mb-4">{svc.tagline}</p>
              <p className="text-zinc-400 leading-relaxed mb-8">{svc.description}</p>
              <div className="flex items-end justify-between border-t border-[#D4AF37]/15 pt-6">
                <div>
                  <div className="text-xs uppercase tracking-[0.2em] text-zinc-500">Starting at</div>
                  <div className="font-serif text-3xl mt-1">
                    <span className="gold-gradient-text">$350</span>
                    <span className="text-sm text-zinc-500 ml-2">/ 4 hrs</span>
                  </div>
                </div>
                <Link
                  to={`/book?service=${key}`}
                  data-testid={`book-${key}`}
                  className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] hover:text-[#F3E5AB] transition-colors flex items-center gap-2"
                >
                  Book Now <ArrowUpRight className="w-4 h-4" />
                </Link>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
